import React, { useEffect, useState } from 'react'
import TabPanel from '../molecules/TabPanel';
import { makeStyles } from '@material-ui/core';
import Player from '../types/Player';
import ViewControls from '../molecules/ViewControls';
import { TEAM_TYPE } from '../templates/UpdatedPlayerPageTemplate';

interface ViewSectionProps {
  player: Player | undefined,
  selectedTeamType: string,
  selectedTab: string,
  isProductionDataAvailable?: boolean,
  isOn3NILValuationAvailable?: boolean,
  setSelectedTab: React.Dispatch<React.SetStateAction<string>>,
  setSelectedTeamType: React.Dispatch<React.SetStateAction<string>>,
}

const TABS_ENUM = {
  OVERVIEW: "Overview",
  HS_RATINGS: "HS Ratings",
  PRODUCTION: "Production",
  VALUATION: "Valuation",
  PPI: "PPI",
  PRO_COMBINE: "Pro Combine",
  IN_GAME: "In-Game",
  COMPS: "Comps"
};
const TABS_VALUES_ENUM = {
  OVERVIEW: "overview",
  HS_RATINGS: "hsRatings",
  PRODUCTION: "production",
  VALUATION: "valuation",
  PPI: "ppi",
  PRO_COMBINE: "proCombine",
  IN_GAME: "inGame",
  COMPS: "comps"
};

const tabsList = [
  {label: TABS_ENUM.OVERVIEW, value: TABS_VALUES_ENUM.OVERVIEW},
  {label: TABS_ENUM.HS_RATINGS, value: TABS_VALUES_ENUM.HS_RATINGS},
  {label: TABS_ENUM.PRODUCTION, value: TABS_VALUES_ENUM.PRODUCTION},
  {label: TABS_ENUM.VALUATION, value: TABS_VALUES_ENUM.VALUATION},
  {label: TABS_ENUM.COMPS, value: TABS_VALUES_ENUM.COMPS}
];

const useStyles = makeStyles(theme => ({
  viewSectionWrap: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    gap: theme.spacing(3),

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
}), { name: ViewSection.name });

export default function ViewSection(props: ViewSectionProps) {
  const {
    player,
    selectedTeamType,
    selectedTab,
    setSelectedTab,
    setSelectedTeamType,
    isProductionDataAvailable,
    isOn3NILValuationAvailable
  } = props;
  const classes = useStyles();

  const [tabs, setTabs] = useState(prepareTabs());

  useEffect(() => {
    setTabs(prepareTabs());
  }, [selectedTeamType, isProductionDataAvailable, isOn3NILValuationAvailable]);

  function prepareTabs() {
    let newTabs = [...tabsList];
    switch (selectedTeamType) {
      case TEAM_TYPE.HIGH_SCHOOL:
        if (selectedTab === TABS_VALUES_ENUM.PPI || selectedTab === TABS_VALUES_ENUM.PRO_COMBINE || selectedTab === TABS_VALUES_ENUM.IN_GAME) {
          setSelectedTab(TABS_VALUES_ENUM.OVERVIEW);
        }
        break;
      case TEAM_TYPE.COLLEGE:
        newTabs = [];
        newTabs = [
          {label: TABS_ENUM.OVERVIEW, value: TABS_VALUES_ENUM.OVERVIEW},
          {label: TABS_ENUM.PRODUCTION, value: TABS_VALUES_ENUM.PRODUCTION},
          {label: TABS_ENUM.PPI, value: TABS_VALUES_ENUM.PPI},
          {label: TABS_ENUM.IN_GAME, value: TABS_VALUES_ENUM.IN_GAME},
          {label: TABS_ENUM.VALUATION, value: TABS_VALUES_ENUM.VALUATION},
          {label: TABS_ENUM.HS_RATINGS, value: TABS_VALUES_ENUM.HS_RATINGS},
          {label: TABS_ENUM.COMPS, value: TABS_VALUES_ENUM.COMPS}
        ];
        break;
      case TEAM_TYPE.NFL:
        newTabs = [];
        newTabs = [
          {label: TABS_ENUM.OVERVIEW, value: TABS_VALUES_ENUM.OVERVIEW},
          {label: TABS_ENUM.PRODUCTION, value: TABS_VALUES_ENUM.PRODUCTION},
          {label: TABS_ENUM.PRO_COMBINE, value: TABS_VALUES_ENUM.PRO_COMBINE},
          {label: TABS_ENUM.PPI, value: TABS_VALUES_ENUM.PPI},
          {label: TABS_ENUM.VALUATION, value: TABS_VALUES_ENUM.VALUATION},
          {label: TABS_ENUM.HS_RATINGS, value: TABS_VALUES_ENUM.HS_RATINGS},
          {label: TABS_ENUM.COMPS, value: TABS_VALUES_ENUM.COMPS}
        ];
        break;
      default:
        newTabs = tabsList;
    }
    if (!isProductionDataAvailable) {
      newTabs = newTabs.map(tab => tab.value === TABS_VALUES_ENUM.PRODUCTION ? {...tab, disabled: true} : tab);
    }
    if (!isOn3NILValuationAvailable) {
      newTabs = newTabs.map(tab => tab.value === TABS_VALUES_ENUM.VALUATION ? {...tab, disabled: true} : tab);
    }
    return newTabs;
  }

  return (
    <div className={classes.viewSectionWrap}>
      <TabPanel 
        tabsList={tabs}
        selectedTab={selectedTab} 
        setSelectedTab={setSelectedTab}
        player={player} 
      />
      <ViewControls
        player={player}
        selectedTeamType={selectedTeamType}
        setSelectedTeamType={setSelectedTeamType}
      />
    </div>
  )
}
